import I18n from 'i18n'

export type MetricId = 'watchWeartime' | 'ecg' | 'questionnaires' | string

export interface MetricDefinition {
  id: MetricId
  labelKey: string
  cardTitle: string
}

export const getResearchDashboardMetrics = (): MetricDefinition[] => {
  return [
    {
      id: 'watchWeartime',
      labelKey: I18n.t('components.dashboards.research_dashboard.watch_weartime_title'),
      cardTitle: I18n.t('components.dashboards.research_dashboard.time_periods.daily')
    },
    {
      id: 'ecg',
      labelKey: I18n.t('components.dashboards.research_dashboard.ecg_title'),
      cardTitle: I18n.t('components.dashboards.research_dashboard.time_periods.weekly')
    },
    {
      id: 'questionnaires',
      labelKey: I18n.t('components.dashboards.research_dashboard.questionnaires_title'),
      cardTitle: I18n.t('components.dashboards.research_dashboard.time_periods.six_months')
    }
  ]
}
